module.exports = __webpack_public_path__ + "img/pr-3.f3888bc5.png";